import { Injectable, signal } from "@angular/core";
import { getSupabaseClient, supabaseSession } from "./supabase.client";
import { Session } from "@supabase/supabase-js";

@Injectable({ providedIn: "root" })
export class AuthService {
  private client = getSupabaseClient();
  session = supabaseSession;

  getSession() {
    return this.session();
  }

  async fetchSession(): Promise<Session | null> {
    const { data } = await this.client.auth.getSession();
    this.session.set(data.session);
    return data.session;
  }

  signIn(email: string, password: string) {
    return this.client.auth.signInWithPassword({ email, password });
  }

  signUp(email: string, password: string) {
    return this.client.auth.signUp({ email, password });
  }

  signOut() {
    return this.client.auth.signOut();
  }
}
